import { FC } from 'react';

//styles
import styles from './footer-legal.module.scss';
import { useIntl } from 'react-intl';

const FooterLegal: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.footerLegalContainer} data-testid="footer-legal">
      <p className={styles.legalPara}>{formatMessage({ id: 'legal' })}</p>
    </div>
  );
};

export default FooterLegal;
